var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('ListView',{attrs:{"with-sites":false,"color":'#538DCB',"items":_vm.tags,"title-field":'name'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }